import { render, staticRenderFns } from "./handle-fba-shipment-modal.vue?vue&type=template&id=223a9145&scoped=true&"
import script from "./handle-fba-shipment-modal.vue?vue&type=script&lang=js&"
export * from "./handle-fba-shipment-modal.vue?vue&type=script&lang=js&"
import style0 from "./handle-fba-shipment-modal.vue?vue&type=style&index=0&id=223a9145&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223a9145",
  null
  
)

export default component.exports